import { ArrowUpRight } from "lucide-react";
import { processSteps, WA_DEMO } from "../../lib/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { Magnetic } from "./Magnetic";

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative py-24 sm:py-32 scroll-mt-20" aria-label="Process">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-7">
        <SectionHeading
          eyebrow="The Process"
          lines={[<>From first call to launch,</>, <>in <em className="italic text-brand">five steps.</em></>]}
          className="mb-12"
        />
        <div className="relative border-l border-line ml-3">
          {processSteps.map((s, i) => (
            <Reveal key={s.num} delay={0.07 * i}>
              <div className="relative pl-10 pb-12 last:pb-0" data-testid={`process-step-${s.num}`}>
                <span className="absolute -left-[7px] top-1.5 w-3.5 h-3.5 bg-ink border-2 border-brand rotate-45" aria-hidden="true" />
                <p className="font-mono text-[10px] tracking-[0.3em] text-brand uppercase">Step {s.num}</p>
                <h3 className="font-display text-2xl sm:text-3xl text-white font-medium mt-2">{s.title}</h3>
                <p className="mt-2.5 text-mute text-sm sm:text-base leading-relaxed max-w-lg">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <Reveal delay={0.15}>
            <div className="relative bg-brand text-ink p-9 sm:p-12 overflow-hidden" data-testid="process-stat-card">
              <span className="absolute -bottom-10 -right-6 font-display font-light text-[11rem] leading-none text-ink/10 select-none" aria-hidden="true">7</span>
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase">The headline number</p>
              <p className="font-display font-light text-6xl sm:text-7xl mt-4 leading-none">
                7 <span className="italic">days</span>
              </p>
              <p className="mt-4 text-ink/80 font-medium max-w-xs">
                Most websites delivered in 7 days — after you approve your free demo.
              </p>
              <Magnetic className="mt-8">
                <a
                  data-testid="process-start-button"
                  href={WA_DEMO}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center gap-3 bg-ink text-white pl-6 pr-1.5 py-1.5 text-sm font-semibold"
                >
                  Start step 01 — it&apos;s free
                  <span className="btn-arrow-box !border-brand/60 !text-brand"><ArrowUpRight size={15} /></span>
                </a>
              </Magnetic>
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-5 text-mute text-xs sm:text-sm" data-testid="process-trust-line">
              No advance until you approve the demo · Unlimited revisions · Full ownership on launch
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
